export default __webpack_public_path__ + "static/conversational_banner-5d7625e562d3bc159dd0ea860225a0df.png";